
/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'
import router from "@/router";
import { loadModules } from "@/api/moduleRegistry";
import { installVersionCheck } from "@/utils/versionCheck";
import i18n from "@/i18n";

// Kick off the module registry fetch as early as possible so router guards
// have a populated map by the time the first navigation resolves.
loadModules().catch(() => {});

// Sync the <html lang> attribute with the initial locale so screen readers
// and browsers know what language the page is in from first paint.
try { document.documentElement.setAttribute('lang', i18n.global.locale.value || 'en'); } catch (_) {}

const app = createApp(App);
app.use(i18n);
app.use(router)
app.mount("#app");

// After the router is wired: detect fresh deploys and prompt open tabs
// to refresh. See src/utils/versionCheck.js for the rationale.
installVersionCheck(router);
